/**
 * Created by Vladislav on 27.03.2025.
 */

const OrderStarsMenuBarItem = {
    name: "OrderStarsItem",
    targets: ["orderStar"],
    value: function () {
        return cleverapps.meta.getSelectedLocation().stars.getAmount();
    },
    updater: function (f) {
        cleverapps.meta.getSelectedLocation().on("changeStars", f, this);
    },
    icon: bundles.menubar.frames.meta_star_png,
    availableOnScenes: [cleverapps.Environment.SCENE_MAIN],
    onClickWindow: () => GuideWindow,
    onClickOptions: {
        name: "OrderStarsGuideWindow",
        bundle: bundles.orderstarsguidewindow
    },
    incEffect: "menubar.reward.star",
    onDebugClick: function () {
        const location = cleverapps.meta.getSelectedLocation();
        location.stars.addStars(100);
    }
};